import {
  GET_LIST_CATEGORIES,
  SET_LIST_VENDORS,
  SET_LIST_PRODUCTS,
  SET_LIST_BRANDS,
  SET_LIST_PRICE_TEMPLATES,
  SET_LIST_PRODUCT_TAGS,
  SET_LIST_MEMBER_GROUPS,
  SET_ADOPTION_MODE,
  SET_FILTER_OPTION,
  SET_COMPLIANCE_LIST,
} from '../types/masterCatalog'

const initState = {
  categories: [],
  categoriesMap: {},
  vendors: [],
  vendorsMap: {},
  products: [],
  priceTemplates: [],
  memberGroups: [],
  batches: [],
  inventory_batches: [],
  adoptionMode: false,
  filter: [],
  brands: [],
  brandsMap: {},
  shopProductTags: [],
  allProductTags: Set,
  complianceCategories: [],
}

export default (state = initState, action) => {
  switch (action.type) {
    case GET_LIST_CATEGORIES:
      const categoriesMap = {}
      if (action.payload && action.payload instanceof Array) {
        action.payload.forEach((cat) => {
          categoriesMap[cat.id] = cat
        })
      }
      return { ...state, categories: action.payload, categoriesMap: categoriesMap }
    case SET_LIST_VENDORS: {
      const vendorsMap = {}
      if (action.payload) {
        action.payload.forEach((ven) => {
          vendorsMap[ven.id] = ven
        })
      }
      return { ...state, vendors: action.payload, vendorsMap: vendorsMap }
    }
    case SET_LIST_PRODUCTS:
      return { ...state, products: action.payload }
    case SET_LIST_BRANDS: {
      const brandsMap = {}
      if (action.payload) {
        action.payload.sort((a, b) => a.name.localeCompare(b.name))
        action.payload.forEach((brand) => {
          brandsMap[brand.id] = brand
        })
      }
      return { ...state, brands: action.payload, brandsMap: brandsMap }
    }
    case SET_LIST_PRICE_TEMPLATES:
      return { ...state, priceTemplates: action.payload }
    case SET_LIST_PRODUCT_TAGS:
      let productTags = []
      if (action.payload) {
        action.payload.forEach((shopPTags) => {
          if (shopPTags && shopPTags.productsTags) {
            productTags = productTags.concat(shopPTags.productsTags)
          }
        })
      }
      productTags.sort()
      return { ...state, shopProductTags: action.payload, allProductTags: new Set(productTags) }
    case SET_LIST_MEMBER_GROUPS:
      return { ...state, memberGroups: action.payload }
    case SET_ADOPTION_MODE:
      return { ...state, adoptionMode: action.payload }
    case SET_FILTER_OPTION:
      return { ...state, filter: action.payload }
    case SET_COMPLIANCE_LIST:
      return { ...state, complianceCategories: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/masterCatalog.js